import React from "react";
import { styled } from "linaria/react";
import { Input } from "antd";
import { theme } from "@project/shared/src/theme";
const Wrapper = /*#__PURE__*/styled("div")({
  name: "Wrapper",
  class: "w4syzeo"
});
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c1pelyqt"
});
const Info = /*#__PURE__*/styled("p")({
  name: "Info",
  class: "iggyyka"
});

const NewsLetter = () => {
  return <Wrapper>
      <Container>
        <Info>
          {"あたらしいチームビルディングや\n合宿体験についてさまざまな情報をお届け"}
        </Info>
        <Input.Search placeholder="メールアドレスを入力" enterButton="メールマガジン登録" />
      </Container>
    </Wrapper>;
};

export { NewsLetter };

require("./index.linaria.module.css!=!../../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");